<template>
  <!-- 底部 -->
  <footer id="footer">
    <div class="btn-list">
      <img src="../assets/images/index/btn1.png" alt class="f-btn" @click="getNotice()" />
      <img src="../assets/images/index/btn2.png" alt class="f-btn" @click="getOrg()" />
      <img
        src="../assets/images/index/btn3.png"
        class="f-btn"
        @click="dialogVisible_question = true"
      />
      <img src="../assets/images/index/btn6.png" alt class="f-btn" @click="quit()" />
      <img
        src="../assets/images/index/btn7.png"
        alt
        class="f-btn"
        @click="goback()"
        v-if="webName != '首页'"
      />
    </div>

    <!-- 账号弹窗 -->
    <el-dialog
      title="账号信息"
      :visible.sync="dialogVisible"
      width="30%"
      :show-close="false"
      custom-class="com-dialog"
    >
      <div class="com-info-box relative">
        <!-- <div class="btn-close" @click="dialogVisible = false">
          <img src="../assets/images/other/btn_close.png" alt width="100%" />
        </div>-->
        <p class="info">
          <span class="i-left">机构名称：</span>
          {{orgInfo.org_name}}
        </p>

        <p class="info">
          <span class="i-left">联系手机号：</span>
          {{orgInfo.org_tel}}
        </p>
        <p class="info" v-for="(item, index) in accountKechengList" :key="index">
          <span class="i-left">{{item.kecheng.cat_name}}：</span>
          {{item.time_start|strSlice}} --- {{item.time_end|strSlice}}
        </p>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>-->
    </el-dialog>

    <!-- 问题反馈弹窗 -->
    <el-dialog
      title="问题反馈"
      :visible.sync="dialogVisible_question"
      width="40%"
      :show-close="false"
      custom-class="com-dialog-question"
    >
      <div class="com-info-box relative">
        <textarea
          name
          cols="30"
          rows="10"
          v-model="question_content"
          placeholder
          class="wtfk"
          id="question-content"
        ></textarea>
      </div>
      <span slot="footer" class="dialog-footer">
        <img
          src="../assets/images/other/btn_esc.png"
          alt
          width="120"
          @click="dialogVisible_question = false"
        />
        <img src="../assets/images/other/btn_submit2.png" alt width="120" @click="addQuestion()" />
      </span>
    </el-dialog>

    <!-- 回复提示 -->
    <el-dialog
      title
      :visible.sync="dialogVisible_reply"
      width="600px"
      :show-close="false"
      custom-class="com-dialog-info "
    >
      <div class="relative">
        <div class="btn-close" @click="dialogVisible_reply = false">
          <img src="../assets/images/other/btn_close.png" alt width="100%" />
        </div>
        <img src="../assets/images/other/info_box.png" alt width="100%" />
        <img
          src="../assets/images/other/btn_submit1.png"
          @click="dialogVisible_reply = false"
          class="btn-info"
        />
        <input type="text" name="info-text" class="info-text" placeholder="请输入。。。" />
      </div>
    </el-dialog>

    <!-- 系统消息 -->
    <el-dialog
      title="系统消息"
      :visible.sync="dialogVisible_notice"
      width="40%"
      :show-close="false"
      custom-class="com-dialog"
    >
      <div class="com-info-box relative">
        <!-- <div class="btn-close" @click="dialogVisible_notice = false">
          <img src="../assets/images/other/btn_close.png" alt width="100%" />
        </div>-->
        <div class="xtxx_line">
          <img src="../assets/images/list/line.png" alt width="100%" />
        </div>
        <div class="info" v-for="(item, index) in listNotice" :key="index">
          <p @click="getNoticeInfo(item.id)" class="pointer">
            {{index+1}}.{{item.title}}
            <span class="fright">{{item.pubdate}}</span>
          </p>
        </div>
      </div>

      <!-- 内层弹窗 -->
      <el-dialog
        width="60%"
        :title="noticeInfo.title"
        custom-class="com-dialog-article "
        :show-close="false"
        :visible.sync="innerVisible"
        append-to-body
      >
        <div class="relative">
          <div class="btn-close" @click="innerVisible = false">
            <img src="../assets/images/other/btn_close.png" alt width="100%" />
          </div>
          <div v-html="noticeInfo.content"></div>
        </div>
      </el-dialog>
    </el-dialog>
  </footer>
</template>

<script>
// @ is an alias to /src
/* eslint-disable */
export default {
  name: "Index",
  props: ["webName"],
  data() {
    return {
      dialogVisible: false,
      dialogVisible_question: false,
      dialogVisible_reply: false,
      dialogVisible_notice: false,
      innerVisible: false,
      question_content: "",
      orgInfo: JSON.parse(localStorage.getItem("orgInfo")),
      accountKechengList: JSON.parse(
        localStorage.getItem("accountKechengList")
      ),
      listNotice: "",
      noticeInfo: "",
    };
  },
  mounted() {},
  methods: {
    goback() {
      this.$router.go(-1);
    },
    // 问题反馈提交
    addQuestion() {
      var that = this;
      if (!this.question_content) {
        alert("请填写反馈内容");
        return false;
      }
      this.$axios({
        method: "GET",
        url: this.apiTp5Url + "/saveMessage",
        params: {
          account_id: this.getCookie("account_id"),
          content: this.question_content,
        },
      })
        .then((response) => {
          //console.log("返回:" + JSON.stringify(response.data));

          if ((response.data.code = 200)) {
            this.dialogVisible_question = false;
            this.$message({
              message: "提交成功",
              type: "success",
              duration: 1000,
              onClose: function () {
                that.question_content = "";
              },
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getOrg() {
      this.dialogVisible = true;
      this.accountKechengList = JSON.parse(
        localStorage.getItem("accountKechengList")
      );
    },
    // 通知获取
    getNotice() {
      this.dialogVisible_notice = true;
      this.$axios({
        method: "GET",
        url: this.apiTp5Url + "/getNoticeList",
        params: {},
      })
        .then((response) => {
          //console.log("返回:" + JSON.stringify(response.data));

          if ((response.data.code = 200)) {
            this.listNotice = response.data.listData;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 通知内容获取
    getNoticeInfo(id) {
      this.innerVisible = true;
      this.$axios({
        method: "GET",
        url: this.apiTp5Url + "/getNoticeInfo",
        params: {
          article_id: id,
        },
      })
        .then((response) => {
          //console.log("返回:" + JSON.stringify(response.data));

          if ((response.data.code = 200)) {
            this.noticeInfo = response.data.dataInfo;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    quit() {
      // this.setCookie("mac", "", -1);
      // this.setCookie("account_id", "", -1);
      // this.$message({
      //   message: "退出成功",
      //   type: "success",
      //   onClose: function () {
      //     window.location.href = "/login";
      //   },
      // });
      this.$confirm("是否要关闭课件平台？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //点击确定的操作(调用接口)
          nw.Window.get().close();
          localStorage.removeItem("arr");
          localStorage.removeItem("page");
        })
        .catch(() => {
          //几点取消的提示
        });
    },
  },
  computed: {},
  filters: {
    strSlice(value) {
      return value.slice(0, 10);
    },
  },
};
</script>
<style>
/* 底部 */
#footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
}
#footer .f-btn {
  width: 40px;
  margin: 15px 20px;
  transition: width 2s;
  -moz-transition: width 2s; /* Firefox 4 */
  -webkit-transition: width 2s; /* Safari and Chrome */
  -o-transition: width 2s; /* Opera */
}
#footer .f-btn:hover {
  zoom: 1.2;
  cursor: pointer;
}
/* 公用弹窗 */
.com-dialog {
  text-align: left;
  background: none;
  margin-top: 30vh !important;
}
.el-dialog {
  background: none;
  border: none;
  box-shadow: none;
}

.el-dialog__header {
}
.el-dialog__header .el-dialog__title {
  font-family: newfont;
  color: #fff;
  font-size: 40px;
  text-shadow: 4px -1px 5px #e98ef7, -4px 1px 5px #e98ef7, 4px -1px 5px #e98ef7,
    -4px -1px 5px #e98ef7;
}

.com-dialog .el-dialog__body {
  padding: 30px 20px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 25px;
  margin: 10px 0;
}

.el-dialog__body a {
  color: #444;
}
.el-dialog__body a:hover {
  color: slateblue;
}

.el-dialog__body .com-info-box .info {
  line-height: 25px;
  font-size: 16px;
}

.el-dialog__body .com-info-box .info .i-left {
  display: inline-block;
  width: 120px;
  text-align: justify;
  text-align-last: justify;
}
/* 关闭按钮 */
.btn-close {
  position: absolute;
  top: -80px;
  right: -35px;
  width: 50px;
}
.dialog-footer {
  text-align: center;
}
.dialog-footer img {
  display: inline-block;
  margin: 10px 70px;
}
/* 问题反馈*/
.com-dialog-question {
  text-align: left;
  margin-top: 30vh !important;
}
#question-content {
  width: 100%;
  border: none;
  background: none;
  outline: none;
}

.com-dialog-question .el-dialog__body {
  padding: 30px 20px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 25px;
  margin-top: 10px;
}

.com-dialog-question .dialog-footer {
  text-align: center;
  display: block;
}

.com-dialog-question .btn-close {
  position: absolute;
  top: -60px;
  right: -35px;
  width: 50px;
}
/* 信息提交 */
.com-dialog-info .el-dialog__body {
  padding: 30px 20px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
}
.com-dialog-info .btn-close {
  position: absolute;
  top: 10px;
  right: -35px;
  width: 50px;
}
.com-dialog-info .btn-info {
  width: 110px;
  position: relative;
  top: -78px;
}
.com-dialog-info input.info-text {
  position: absolute;
  top: 90px;
  left: 80px;
  width: 400px;
  line-height: 45px;
  font-size: 16px;
  border: none;
  outline: none;
  background: none;
}

.wtfk {
  resize: none;
  font-size: 20px;
  letter-spacing: 1px;
  line-height: 30px;
}

/* 文章内容 */
/* 信息提交 */
.com-dialog-article .el-dialog__body {
  height: 350px;
  border-radius: 8px;
}
.com-dialog-article .btn-close {
  position: absolute;
  top: -60px;
  right: -35px;
  width: 50px;
}
</style>
